import { supabase } from '@/integrations/supabase/client';
import { Json } from '@/integrations/supabase/types';

export type AuditAction = 
  | 'login_attempt'
  | 'login_success'
  | 'login_failed'
  | 'logout'
  | 'property_created'
  | 'property_updated'
  | 'property_deleted'
  | 'admin_email_added'
  | 'admin_email_deleted'
  | 'contact_read'
  | 'contact_deleted'
  | 'newsletter_updated'
  | 'newsletter_deleted';

export type ResourceType = 
  | 'auth'
  | 'property'
  | 'admin_email'
  | 'contact'
  | 'newsletter';

interface AuditLogEntry {
  action: AuditAction;
  resourceType?: ResourceType;
  resourceId?: string;
  details?: Json;
  success?: boolean;
  userEmail?: string;
}

export const logAuditEvent = async ({
  action,
  resourceType,
  resourceId,
  details,
  success = true,
  userEmail,
}: AuditLogEntry) => {
  try {
    const { data: { user } } = await supabase.auth.getUser();
    
    await supabase.from('audit_logs').insert([{
      user_id: user?.id || null,
      user_email: userEmail || user?.email || null,
      action,
      resource_type: resourceType || null,
      resource_id: resourceId || null,
      details: details || null,
      success,
    }]);
  } catch (error) {
    // Silently fail - don't block operations if audit logging fails
    console.error('Audit log failed:', error);
  }
};

export const useAuditLog = () => {
  return { logAuditEvent };
};
